import { createRoot } from 'react-dom/client';
import { ThemeProvider } from 'styled-components';
import './i18n';
import { App } from './App';
import { GameProvider } from './net/GameProvider';
import { GlobalStyle } from './styles/GlobalStyle';
import { theme } from './styles/theme';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

// Deliberately not wrapped in <StrictMode>: its double-invoked effects would
// open, close and reopen the game WebSocket on every mount in development,
// which makes the connection lifecycle much harder to reason about.
createRoot(container).render(
  <ThemeProvider theme={theme}>
    <GlobalStyle />
    <GameProvider>
      <App />
    </GameProvider>
  </ThemeProvider>,
);
